import { defineMessage } from 'services/localization';

export const messages = {
    categoryColumnName: defineMessage('category'),
    accountColumnName: defineMessage('account'),
    taxCodeColumnName: defineMessage('tax_code'),
    taxRateColumnName: defineMessage('tax_rate'),
    taxAmountColumnName: defineMessage('tax_amount'),
    grossAmountColumnName: defineMessage('gross_amount'),
    memoColumnName: defineMessage('memo'),
    departmentColumnName: defineMessage('department'),
    classColumnName: defineMessage('class'),
    locationColumnName: defineMessage('location'),
    isBillableColumnName: defineMessage('billable'),
    descriptionColumnName: defineMessage('description'),
    billedColumnName: defineMessage('billed'),
    quantityColumnName: defineMessage('qty'),
    itemColumnName: defineMessage('item'),
    vendorNameColumnName: defineMessage('vendor_name'),
    unitsColumnName: defineMessage('units'),
    customerColumnName: defineMessage('customer'),
    amountColumnName: defineMessage('amount'),
    unitPriceColumnName: defineMessage('rate'),
    remainingColumnName: defineMessage('remaining'),
    linkedColumnName: defineMessage('linked'),
};
